import { render, staticRenderFns } from "./EditBorrowIcon.vue?vue&type=template&id=3685fd5e&"
import script from "./EditBorrowIcon.vue?vue&type=script&lang=js&"
export * from "./EditBorrowIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports